module.exports = __webpack_public_path__ + "img/gift-live.8d6d39f6.png";